import { render, staticRenderFns } from "./InspectionDashboard.vue?vue&type=template&id=97303b2e&scoped=true"
import script from "./InspectionDashboard.vue?vue&type=script&lang=js"
export * from "./InspectionDashboard.vue?vue&type=script&lang=js"
import style0 from "./InspectionDashboard.vue?vue&type=style&index=0&id=97303b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97303b2e",
  null
  
)

export default component.exports